// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
[data-v-37445ea6] .vdp-datepicker {

      display: block;

      border-radius: 12px;

      border-width: 1px;

      --tw-border-opacity: 1;

      border-color: rgb(156 163 175 / var(--tw-border-opacity))
}
[data-v-37445ea6] .vdp-datepicker:hover {

      cursor: pointer
}
[data-v-37445ea6] .vdp-datepicker input {

      width: 100%;

      padding-left: 1rem;

      padding-right: 1rem;

      padding-top: 0.75rem;

      padding-bottom: 0.75rem;

      --tw-text-opacity: 1;

      color: rgb(17 24 39 / var(--tw-text-opacity));

      font-family: Roboto;

      line-height: 1.5;

      font-size: 1rem;

      font-weight: 400
}
[data-v-37445ea6] .vdp-datepicker input:focus {

      outline: 2px solid transparent;

      outline-offset: 2px
}
[data-v-37445ea6] .vdp-datepicker input:disabled {

      --tw-bg-opacity: 1;

      background-color: rgb(243 244 246 / var(--tw-bg-opacity))
}
[data-v-37445ea6] .vdp-datepicker__calendar {

      width: 18.75rem;

      overflow: hidden;

      border-radius: 12px;

      border-width: 1px;

      --tw-border-opacity: 1;

      border-color: rgb(209 213 219 / var(--tw-border-opacity))
}
[data-v-37445ea6] .vdp-datepicker__calendar .prev,[data-v-37445ea6] .vdp-datepicker__calendar .next {

      position: relative
}
[data-v-37445ea6] .vdp-datepicker__calendar .prev .default,[data-v-37445ea6] .vdp-datepicker__calendar .next .default {

      height: 100%;

      width: 100%;

      background-position: center;

      background-repeat: no-repeat;

      background-image: url('/img/web/icons/arrow.svg')
}
[data-v-37445ea6] .vdp-datepicker__calendar .prev .default::after,[data-v-37445ea6] .vdp-datepicker__calendar .next .default::after {

      border-width: 0px;

      border-style: none
}
[data-v-37445ea6] .vdp-datepicker__calendar .prev .default {

      --tw-rotate: 90deg;

      transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}
[data-v-37445ea6] .vdp-datepicker__calendar .next .default {

      --tw-rotate: -90deg;

      transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}
[data-v-37445ea6] .vdp-datepicker__calendar .picker-view {

      padding: 0.75rem
}
[data-v-37445ea6] .vdp-datepicker__calendar .cell.day,[data-v-37445ea6] .vdp-datepicker__calendar .cell.month,[data-v-37445ea6] .vdp-datepicker__calendar .cell.year {

      border-width: 0px;

      border-style: none;

      --tw-text-opacity: 1;

      color: rgb(31 41 55 / var(--tw-text-opacity))
}
[data-v-37445ea6] .vdp-datepicker__calendar .cell.day.muted,[data-v-37445ea6] .vdp-datepicker__calendar .cell.month.muted,[data-v-37445ea6] .vdp-datepicker__calendar .cell.year.muted {

      --tw-text-opacity: 1;

      color: rgb(156 163 175 / var(--tw-text-opacity))
}
[data-v-37445ea6] .vdp-datepicker__calendar .cell.day.today,[data-v-37445ea6] .vdp-datepicker__calendar .cell.month.today,[data-v-37445ea6] .vdp-datepicker__calendar .cell.year.today {

      --tw-bg-opacity: 1;

      background-color: rgb(209 213 219 / var(--tw-bg-opacity));

      --tw-text-opacity: 1 !important;

      color: rgb(156 163 175 / var(--tw-text-opacity)) !important
}
[data-v-37445ea6] .vdp-datepicker__calendar .cell.day.selected,[data-v-37445ea6] .vdp-datepicker__calendar .cell.month.selected,[data-v-37445ea6] .vdp-datepicker__calendar .cell.year.selected {

      --tw-bg-opacity: 1;

      background-color: rgb(129 197 238 / var(--tw-bg-opacity))
}
[data-v-37445ea6] .vdp-datepicker__calendar .cell.day.disabled,[data-v-37445ea6] .vdp-datepicker__calendar .cell.month.disabled,[data-v-37445ea6] .vdp-datepicker__calendar .cell.year.disabled {

      --tw-text-opacity: 1;

      color: rgb(209 213 219 / var(--tw-text-opacity))
}
[data-v-37445ea6] .vdp-datepicker__calendar .cell.day:hover:not(.selected),[data-v-37445ea6] .vdp-datepicker__calendar .cell.month:hover:not(.selected),[data-v-37445ea6] .vdp-datepicker__calendar .cell.year:hover:not(.selected) {

      border-width: 0px;

      border-style: none;

      --tw-bg-opacity: 1;

      background-color: rgb(219 238 250 / var(--tw-bg-opacity))
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/components/inputs/date/DateInput.vue"],"names":[],"mappings":";AAyFA;;MAAA,cAAA;;MAAA,mBAAA;;MAAA,iBAAA;;MAAA,sBAAA;;MAAA;AAAA;AAAA;;MAAA;AAAA;AAGA;;MAAA,WAAA;;MAAA,kBAAA;;MAAA,mBAAA;;MAAA,oBAAA;;MAAA,uBAAA;;MAAA,oBAAA;;MAAA,6CAAA;;MAAA,mBAAA;;MAAA,gBAAA;;MAAA,eAAA;;MAAA;AAAA;AAAA;;MAAA,8BAAA;;MAAA;AAAA;AAAA;;MAAA,kBAAA;;MAAA;AAAA;AAIA;;MAAA,eAAA;;MAAA,gBAAA;;MAAA,mBAAA;;MAAA,iBAAA;;MAAA,sBAAA;;MAAA;AAAA;AAIA;;MAAA;AAAA;AAEA;;MAAA,YAAA;;MAAA,WAAA;;MAAA,2BAAA;;MAAA,4BAAA;;MAEA;AAFA;AAKA;;MAAA,iBAAA;;MAAA;AAAA;AAMA;;MAAA,kBAAA;;MAAA;AAAA;AAKA;;MAAA,mBAAA;;MAAA;AAAA;AAKA;;MAAA;AAAA;AAMA;;MAAA,iBAAA;;MAAA,kBAAA;;MAAA,oBAAA;;MAAA;AAAA;AAGA;;MAAA,oBAAA;;MAAA;AAAA;AAGA;;MAAA,kBAAA;;MAAA,yDAAA;;MAAA,+BAAA;;MAAA;AAAA;AAGA;;MAAA,kBAAA;;MAAA;AAAA;AAGA;;MAAA,oBAAA;;MAAA;AAAA;AAGA;;MAAA,iBAAA;;MAAA,kBAAA;;MAAA,kBAAA;;MAAA;AAAA","sourcesContent":["<template>\n  <FormulateInput\n    class=\"input-date\"\n    :key=\"value\"\n    type=\"triotecaDatepicker\"\n    placeholder=\"Selecciona una fecha\"\n    language=\"es\"\n    first-day-of-week=\"mon\"\n    :typeable=\"true\"\n    :format=\"customFormatter\"\n    :parser=\"customParser\"\n    :disabled-dates=\"disabledDates\"\n    v-bind=\"$attrs\"\n    :value=\"value\"\n  >\n  </FormulateInput>\n</template>\n<script>\nimport { computed } from '@vue/composition-api';\nimport { format, parse } from 'date-fns';\nimport { MAXAGE } from '@/constants/age';\n\nexport default {\n  props: {\n    value: {\n      type: String,\n    },\n  },\n  data() {\n    return {\n      format: 'dd/MM/yyyy',\n    };\n  },\n  setup(props, { root }) {\n    const disabledDates = computed(() => {\n      return (\n        root.$attrs.disabledDates ?? {\n          to: oldest,\n        }\n      );\n    });\n\n    const youngest = computed(() => {\n      var young = new Date();\n      young.setFullYear(young.getFullYear() + MAXAGE);\n      return young;\n    });\n\n    const oldest = computed(() => {\n      const old = new Date();\n      old.setFullYear(old.getFullYear() - MAXAGE);\n      old.setDate(old.getDate() - 1);\n      return old;\n    });\n\n    const customFormatter = (date) => {\n      return format(date, 'dd/MM/yyyy');\n    };\n\n    const customParser = (date) => {\n      const [day, month, year] = date.split('/');\n      if (year && year.length > 3 && isAncientDate(year, month, day)) {\n        const res = parse(new Date(youngest.value).getDate(), 'dd/MM/yyyy', new Date());\n        return res;\n      }\n      return parse(date, 'dd/MM/yyyy', new Date());\n    };\n\n    const isAncientDate = (year, month, day) => {\n      const old = new Date(oldest.value).getTime();\n      const ancient = new Date(year, month || '01', day || '01').getTime();\n      return old > ancient;\n    };\n\n    return {\n      customFormatter,\n      customParser,\n      disabledDates,\n    };\n  },\n};\n</script>\n\n<style lang=\"postcss\">\n@import '@sum.cumo/vue-datepicker/dist/Datepicker.css';\n</style>\n\n<style lang=\"postcss\" scoped>\n/deep/ .vdp-datepicker {\n  @apply block border-hairline border-neutral-medium rounded-md hover:cursor-pointer;\n\n  input {\n    @apply w-full px-xxxs text-neutral-ultradark py-micro disabled:bg-neutral-lightest style-body-sm focus:outline-none;\n  }\n}\n/deep/ .vdp-datepicker__calendar {\n  @apply rounded-md border-hairline border-neutral-semilight w-[18.75rem] overflow-hidden;\n\n  .prev,\n  .next {\n    @apply relative;\n    .default {\n      @apply w-full h-full bg-center bg-no-repeat;\n\n      background-image: url('/img/web/icons/arrow.svg');\n\n      &::after {\n        @apply border-none;\n      }\n    }\n  }\n  .prev {\n    .default {\n      @apply rotate-90;\n    }\n  }\n  .next {\n    .default {\n      @apply -rotate-90;\n    }\n  }\n\n  .picker-view {\n    @apply p-micro;\n  }\n\n  .cell.day,\n  .cell.month,\n  .cell.year {\n    @apply border-none text-neutral-darkest;\n\n    &.muted {\n      @apply text-neutral-medium;\n    }\n    &.today {\n      @apply bg-neutral-semilight !text-neutral-medium;\n    }\n    &.selected {\n      @apply bg-support-medium;\n    }\n    &.disabled {\n      @apply text-neutral-semilight;\n    }\n    &:hover:not(.selected) {\n      @apply border-none bg-support-light;\n    }\n  }\n}\n</style>"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
